import yup from '../yup';

export const userEditSchema = yup.object().shape({
  name: yup.string()
    .max(30, '名は30文字以下で入力してください。')
    .required('名を入力してください。')
    .nullable()
    .label('名'),
  surname: yup.string()
    .max(30, '姓は30文字以下で入力してください。')
    .required('姓を入力してください。')
    .nullable()
    .label('姓'),
});
